module.exports = __webpack_public_path__ + "media/images/client-26-dabe814459e3ba256b0764d9ab150840.png";